import { useState } from "react";
import { toast } from "sonner";
import { Heart, Lock } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { Field } from "@/components/site/Field";

const PRESETS = [5, 11, 22, 33];

export const DonationForm = () => {
  const [amount, setAmount] = useState("11");
  const [form, setForm] = useState({ name: "", email: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    const value = parseFloat(amount);
    if (!(value >= 5)) return toast.error("The smallest donation is $5");
    setLoading(true);
    try {
      const { data } = await api.post("/donations/checkout", {
        amount: value, name: form.name || null, email: form.email || null, origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(errorText(err));
      setLoading(false);
    }
  };

  return (
    <div id="donate" className="glass rounded-[2rem] p-8 md:p-12" data-testid="donation-section">
      <p className="eyebrow">Love offering</p>
      <h3 className="font-display gold-text text-3xl md:text-4xl mt-3">Give a Donation</h3>
      <p className="mt-4 text-[#f7f1e1]/75">Any amount from $5. Your gift keeps the circle open to every soul who needs it.</p>
      <form onSubmit={submit} className="space-y-5 mt-8" data-testid="donation-form">
        <div className="grid grid-cols-4 gap-3">
          {PRESETS.map((p) => (
            <button type="button" key={p} className="choice text-center font-cinzel text-[#f1d57a]" data-active={amount === String(p)} onClick={() => setAmount(String(p))} data-testid={`donation-preset-${p}`}>${p}</button>
          ))}
        </div>
        <Field label="Amount (USD)">
          <input required type="number" min="5" step="0.01" inputMode="decimal" className="field" value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="donation-amount-input" />
        </Field>
        <div className="grid sm:grid-cols-2 gap-5">
          <Field label="Name (optional)"><input className="field" placeholder="Your name" value={form.name} onChange={set("name")} data-testid="donation-name-input" /></Field>
          <Field label="Email (optional)"><input type="email" className="field" placeholder="you@email.com" value={form.email} onChange={set("email")} data-testid="donation-email-input" /></Field>
        </div>
        <div className="flex flex-wrap items-center gap-5">
          <button type="submit" disabled={loading} className="btn-gold inline-flex items-center gap-2" data-testid="donation-submit-btn"><Heart size={14} /> {loading ? "Opening checkout..." : "Give with Love"}</button>
          <span className="inline-flex items-center gap-2 text-xs text-[#f7f1e1]/55"><Lock size={12} /> Secure by Stripe</span>
        </div>
      </form>
    </div>
  );
};
